function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import PropTypes from 'prop-types';
import React from 'react';
import Alert from "./Alert";
import Button from "./Button";

var DeletedNote = function DeletedNote(_ref) {
  var props = _extends({}, _ref);

  var className = props.className,
      note = props.note,
      onUndelete = props.onUndelete;
  return (
    /*#__PURE__*/
    React.createElement(Alert, {
      color: "success",
      icon: true,
      className: className
    },
    /*#__PURE__*/
    React.createElement("span", {
      className: "align-middle"
    }, "Note deleted."), onUndelete &&
    /*#__PURE__*/
    React.createElement(Button, {
      color: "link",
      onClick: function onClick() {
        return onUndelete(note);
      },
      className: "ml-1 p-0"
    }, "undo"))
  );
};

DeletedNote.displayName = "DeletedNote";
DeletedNote.propTypes = {
  className: PropTypes.string,
  note: PropTypes.shape({
    date: PropTypes.instanceOf(Date),
    deleted: PropTypes.bool,
    edited: PropTypes.bool,
    editing: PropTypes.bool,
    from: PropTypes.string,
    errors: PropTypes.string,
    text: PropTypes.string.isRequired
  }).isRequired,
  onUndelete: PropTypes.func
};
export default DeletedNote;